import DressageSteps from "./DressageSteps";

export default class DressageProtocol {
  constructor(private readonly _id: string,
              private readonly _series: string,
              private readonly _protocolNumber: string,
              private readonly _period: string,
              private readonly _remarks: string,
              private readonly _arenaDimensions: string,
              private readonly _dressageSteps: DressageSteps) {
  }

  get id(): string {
    return this._id;
  }

  get series(): string {
    return this._series;
  }

  get protocolNumber(): string {
    return this._protocolNumber;
  }

  get period(): string {
    return this._period;
  }

  get remarks(): string {
    return this._remarks;
  }

  get arenaDimensions(): string {
    return this._arenaDimensions;
  }

  get dressageSteps(): DressageSteps {
    return this._dressageSteps;
  }
}
